import React from 'react';
import PDFBuilder from './PDFBuilder';
import './SettingsPage.css';

function SettingsPage({ user, org, onClose }) {
  const isAdmin = user.role === 'admin' || user.role === 'superadmin';

  return (
    <div className="settings-page">
      <div className="settings-header">
        <div className="settings-header-left">
          <button className="settings-back-btn" onClick={onClose}>
            ← Back to Dashboard
          </button>
          <div className="settings-title-group">
            <h1>Organization Settings</h1>
            <p className="settings-subtitle">{org ? org.name : 'ReportFlow'}</p>
          </div>
        </div>
      </div>

      <div className="settings-content">
        <div className="settings-section">
          <div className="settings-section-header">
            <h2>PDF Report Template</h2>
            <p>Customize which analytics appear in your generated reports. Changes apply to all clients in your organization.</p>
          </div>
          {isAdmin ? (
            <PDFBuilder user={user} />
          ) : (
            <div className="settings-no-access">
              <p>You need admin access to customize the report template. Contact your organization admin.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default SettingsPage;
